import { BUILTIN_VEHICLES, totalMass, type Vehicle } from '@rcs/data-schema';
import { useId } from 'react';
import { vehicleFacts } from '../course/vehicle-spec';
import { messages } from '../i18n/ja';

/**
 * 車両の選択（FR-VEH）。蒸気機関車・新幹線・リニアモーターカー・スポーツカー・自転車などから選ぶ。
 * 選んだ車両の質量・空気抵抗・転がり抵抗・限界値が、走行の計算に使われ、3D の車両と乗客も変わる。
 * 車両の要点と説明を、選択欄の下に文言で示す。
 */
export function VehiclePanel({
  vehicle,
  onSelect,
}: {
  readonly vehicle: Vehicle | undefined;
  readonly onSelect: (id: string) => void;
}) {
  const t = messages.vehicle;
  const id = useId();
  const facts = vehicle ? vehicleFacts(vehicle, totalMass(vehicle)) : undefined;
  return (
    <section className="vehicle-panel" aria-label={t.title} data-testid="vehicle-panel">
      <div className="number-field">
        <label htmlFor={id} className="number-field__label">
          {t.select}
        </label>
        <select
          id={id}
          value={vehicle?.id ?? ''}
          data-testid="vehicle-select"
          onChange={(event) => {
            onSelect(event.target.value);
          }}
        >
          {BUILTIN_VEHICLES.map((v) => (
            <option key={v.id} value={v.id}>
              {v.name}
            </option>
          ))}
        </select>
      </div>
      {vehicle && facts && (
        <>
          <p className="vehicle-panel__facts" data-testid="vehicle-facts">
            {t.facts
              .replace(
                '{mass}',
                facts.massTons >= 10 ? facts.massTons.toFixed(0) : facts.massTons.toFixed(2),
              )
              .replace('{length}', facts.lengthMeters.toFixed(1))
              .replace('{capacity}', String(facts.capacity))
              .replace('{speed}', facts.maxSpeedKmh.toFixed(0))}
          </p>
          <p className="vehicle-panel__description" data-testid="vehicle-description">
            {vehicle.description}
          </p>
        </>
      )}
    </section>
  );
}
